import Convo_signalr from "@/modules/crm/leads/convo-signalr-contants";
import Lead_signalr from "@/modules/crm/leads/signalr-constants";
import WF_signalr from "@/modules/crm/automation/workflow-signalr-constants";
import Report_Dashboard_signalr from "@/modules/crm/analytics/report-dashboard-signalr-constants";
import Appointment_signalr from "@/modules/crm/appointment/appointment-signalr-constants";
import Task_signalr from "./task-signalR-constants";

const RootHub = [
  { ...Lead_signalr },
  { ...Convo_signalr },
  { ...Task_signalr },
  { ...WF_signalr },
  { ...Report_Dashboard_signalr },
  { ...Appointment_signalr },
];

export default RootHub;
